import { Component, Input, OnInit } from '@angular/core';
import { InsuranceService } from '../../../services/insurance.service';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

@Component({
  selector: 'gtd-insurance-confirmation',
  templateUrl: './insurance-confirmation.component.html',
  styleUrls: ['./insurance-confirmation.component.scss']
})
export class InsuranceConfirmationComponent implements OnInit {
  @Input() type: 'DOME' | 'INTE';
  planSelected$ = this.insuranceService.planSelected$;
  label$: Observable<string>;
  constructor(private insuranceService: InsuranceService) {}

  ngOnInit() {
    this.label$ = this.planSelected$.pipe(
      filter(plan => !!plan),
      map(plan => this.insuranceService.getPlanLabel(this.type, plan.planType))
    );
  }
}
